module.exports = __webpack_public_path__ + "static/media/coliseu_box_2.c6eb0fea.jpg";